<div class="action-menu-view">
  <mat-menu #appMenu="matMenu">
    <button
      *ngFor="let action of actions"
      class="action action-menu-view-button"
      mat-menu-item
      (click)="click(action)"
    >
      <mat-icon color="accent">{{ action.icon }}</mat-icon>
      <div class="header">{{ action.header }}</div>
    </button>
  </mat-menu>

  <button
    class="more"
    mat-icon-button
    color="accent"
    [disabled]="actions.length === 0"
    [matMenuTriggerFor]="appMenu"
  >
    <span>Actions</span>
    <mat-icon *ngIf="!isVertical">more_horiz</mat-icon>
    <mat-icon *ngIf="isVertical">more_vert</mat-icon>
  </button>
</div>
